import React, { useEffect, useRef, useState } from "react";
import SubHeader from "../../../components/SubHeader";
import SiteButtons from "../../../components/SiteButtons";
import { useHref, useNavigate } from "react-router-dom";
import { URLS } from "../../../_config";
import Container from "../../../components/Container";
import { Controller, set, useForm } from "react-hook-form";
import Input from "../../../components/elements/form/input";
import CommonDropdown from "../../../components/elements/form/commonDropdown";
import Textarea from "../../../components/elements/form/textarea";
import { useLookup, getLookupDisplayValue } from "../../../_common/hookFunction";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import Icon from "../../../components/icons";
import SelectBox from "../../../components/elements/form/selectBox";
import Label from "../../../components/elements/form/fromLabel";
import moment from "moment";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import { useDiscountsApi } from "../../../store/api/hooks/discountsApiHook";
import toast from "react-hot-toast";
import { createPositiveDecimalNumberHandler, createPositiveWholeNumberHandler,getPositiveDecimalNumberInputProps } from "../../../_common/validationUtils";
import DecimalInput from "../../../components/elements/form/DecimalInput";
import { navigationConfirm } from "../../../_common/functions";
import { useDialog } from "../../../store/api/hooks/dialogHook";
import { Tooltip } from "react-daisyui";
import { useTranslation } from "react-i18next";

interface Props {
    type?: any;
    discount?: any;
}
type formValues = {
    discountId: string | null;
    fkDiscountTypeLookupValueId: string | null;
    discountName: string;
    discountDescription: string;
    isAutomatic: boolean;
    discountCode: string;
    isSetDateRange: boolean;
    isSetSchedule: boolean;
    active: boolean;
    fkCustomerTargetTypeLookupValueId: string;
    ui_maxdiscountallowed: string | null;
    discountCombination: Array<{ fkCombinationsLookupValueId: string; }>;
    customerGroups: Array<{ discountCustomerGroupId: string; fkCustomerGroupId: string; active: boolean }>;
    locations: Array<{ discountLocationId: string; fkLocationId: string; active: boolean; }>;
    products: Array<{ discountProductId: string; fkProductId: string; fkProductVariantDetailId: string; fkProductRoleLookupValueId: string; requiredQuantity: string; }>;
    rules: Array<{
        discountRuleId: string;
        fkDiscountValueTypeLookupValueId: any | null;
        discountValue: string;
        fkMinimumRequirementTypeLookupValueId: string | null;
        minPurchaseAmount: string;
        minPurchaseQty: string;
        maxPurchaseQty: string | null;
        fkMaxLimitTypeLookupValueId: string | null;
        maxAllowedQty: string | null;
        maxAllowedValue: string | null;
        totalUsageLimit: any;
        limitToOneUsePerCustomer: boolean;
        requiredQuantity: string | null;
        active: boolean;
    }>;
    dateRanges: Array<{ discountScheduleDateRangeId: string; startDate: any; endDate: any; }>;
    weeklySchedules: Array<{ discountScheduleWeeklyId: string; dayOfWeek: string; startTime: any; endTime: any; isActive: boolean }>;
};


const OrderDiscount: React.FC<Props> = ({ type, discount = null }) => {
    const { t, i18n } = useTranslation("discounts");
    const navigate = useNavigate();
    const discountApi = useDiscountsApi();
    const {confirm} = useDialog();
    const [saving, setSaving] = useState<boolean>(false);
    const [discountCombinations, setDiscountCombinations] = useState<any[]>([]);

    const { control, setValue, getValues, handleSubmit, formState: { errors }, watch, trigger, setFocus } = useForm<formValues>({
        defaultValues: {
            discountId: null,
            fkDiscountTypeLookupValueId: type,
            discountName: ``,
            discountDescription: ``,
            isAutomatic: false,
            discountCode: ``,
            isSetDateRange: false,
            isSetSchedule: false,
            active: true,
            fkCustomerTargetTypeLookupValueId: btoa(`139`),
            ui_maxdiscountallowed: null,
            discountCombination: [],
            customerGroups: [],
            locations: [],
            products: [],
            rules: [{
                discountRuleId: ``,
                fkDiscountValueTypeLookupValueId: null,
                discountValue: `0.00`,
                fkMinimumRequirementTypeLookupValueId: null,
                minPurchaseAmount: `0.00`,
                minPurchaseQty: `0`,
                maxPurchaseQty: null,
                fkMaxLimitTypeLookupValueId: null,
                maxAllowedQty: null,
                maxAllowedValue: null,
                totalUsageLimit: `1`,
                limitToOneUsePerCustomer: false,
                requiredQuantity: null,
                active: true
            }],
            dateRanges: [{ discountScheduleDateRangeId: ``, startDate: ``, endDate: `` }],
            weeklySchedules: [
                { discountScheduleWeeklyId: ``, dayOfWeek: `1`, startTime: ``, endTime: ``, isActive: false },
                { discountScheduleWeeklyId: ``, dayOfWeek: `2`, startTime: ``, endTime: ``, isActive: false },
                { discountScheduleWeeklyId: ``, dayOfWeek: `3`, startTime: ``, endTime: ``, isActive: false },
                { discountScheduleWeeklyId: ``, dayOfWeek: `4`, startTime: ``, endTime: ``, isActive: false },
                { discountScheduleWeeklyId: ``, dayOfWeek: `5`, startTime: ``, endTime: ``, isActive: false },
                { discountScheduleWeeklyId: ``, dayOfWeek: `6`, startTime: ``, endTime: ``, isActive: false },
                { discountScheduleWeeklyId: ``, dayOfWeek: `0`, startTime: ``, endTime: ``, isActive: false }
            ]
        }
    });
    const discountType = watch(`rules.0.fkDiscountValueTypeLookupValueId`)
    ? watch(`rules.0.fkDiscountValueTypeLookupValueId.value`)
    : null;
    const discountValue = Number(watch(`rules.0.discountValue`)) || 0;
    useEffect(() => {
      if(discountValue>100 && discountType == 48){
     setValue("rules.0.discountValue", "0");}
    }, [discountType, setValue]);

    useEffect(() => {
        setFocus("discountName");
    }, [setFocus]);

    const { showLoader, hideLoader } = useAppLoader();
    const maxdiscountrenderRef = useRef<boolean>(false);
    const dayNameObj = { 0: t("orderDiscount.schedule.dayNames.sunday"), 1: t("orderDiscount.schedule.dayNames.monday"), 2: t("orderDiscount.schedule.dayNames.tuesday"), 3: t("orderDiscount.schedule.dayNames.wednesday"), 4: t("orderDiscount.schedule.dayNames.thursday"), 5: t("orderDiscount.schedule.dayNames.friday"), 6: t("orderDiscount.schedule.dayNames.saturday") };
    const lookup = useLookup();
    const isAutomaticWatch = watch("isAutomatic");
    const ui_minrequirementtyopevalues = watch("rules.0.fkMinimumRequirementTypeLookupValueId");
    const ui_maxdiscountallowedWatch = watch("ui_maxdiscountallowed");
    const weeklySchedulesWatch: any = watch("weeklySchedules");
    const isSetDateRangeWatch: boolean = watch("isSetDateRange");
    const isSetScheduleWatch: boolean = watch("isSetSchedule");
    const schedulestartdateWatch: any = watch("dateRanges.0.startDate");
    const scheduleenddateWatch: any = watch("dateRanges.0.endDate");
    const fkCustomerTargetTypeLookupValueIdWatch = watch("fkCustomerTargetTypeLookupValueId");

    const generateUniqueCode = (length = 5): string => {
        const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
        let code = '';
        for (let i = 0; i < length; i++) {
            code += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return code.toUpperCase();
    }

    const formatDateForAPI = (date: Date | null, isEnd: boolean = false) => {
      if (!date) return undefined;
      if (isEnd) {
        return (
          moment(date).endOf("day").utc().format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z"
          // moment(date).endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z"
        );
      }
      return (
        moment(date).startOf("day").utc().format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z"
        // moment(date).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z"
      );
    };

    const onSubmit = async (data: formValues) => {
        console.log("Form data is: ->", data);
        const payload = Object.assign({}, JSON.parse(JSON.stringify(data)));
        
        // Add discountCombinations state to the data for processing
        const enhancedData = {
            ...data,
            discountCombination: discountCombinations
        };
        if (enhancedData && enhancedData?.locations && Array.isArray(enhancedData.locations) && enhancedData.locations.length > 0) {
            payload.locations = enhancedData.locations.map((x: any) => {
                const lobj = { discountLocationId: null, fkLocationId: x.value, active: true }
                if (discount && discount.locations && Array.isArray(discount.locations)) {
                    console.log(discount.locations, x.value)
                    const existLocaton = discount.locations.find((y: any) => y.fkLocationId == x.value);
                    if (existLocaton) {
                        lobj.discountLocationId = existLocaton.discountLocationId;
                    }
                }
                return lobj;
            });
        }

        // Process customer groups
        if (enhancedData && enhancedData?.customerGroups && Array.isArray(enhancedData.customerGroups) && enhancedData.customerGroups.length > 0) {
            payload.customerGroups = enhancedData.customerGroups.map((x: any) => {
                const cgobj = { discountCustomerGroupId: null, fkCustomerGroupId: x.value, active: true }
                if (discount && discount.customerGroups && Array.isArray(discount.customerGroups)) {
                    const existCustomerGroup = discount.customerGroups.find((y: any) => y.fkCustomerGroupId == x.value);
                    if (existCustomerGroup) {
                        cgobj.discountCustomerGroupId = existCustomerGroup.discountCustomerGroupId;
                    }
                }
                return cgobj;
            });
        } else {
            payload.customerGroups = [];
        }

        if (enhancedData && enhancedData?.rules && Array.isArray(enhancedData.rules) && enhancedData.rules.length > 0) {
            payload.rules = enhancedData.rules.map((x: any) => ({
                discountRuleId: null,
                fkDiscountValueTypeLookupValueId: (x.fkDiscountValueTypeLookupValueId && typeof x.fkDiscountValueTypeLookupValueId !== `undefined` && x.fkDiscountValueTypeLookupValueId?.value) ? btoa(x.fkDiscountValueTypeLookupValueId.value) : ``,
                discountValue: x.discountValue ? parseFloat(x.discountValue).toFixed(2) : "0.00",
                fkMinimumRequirementTypeLookupValueId: (x.fkMinimumRequirementTypeLookupValueId && typeof x.fkMinimumRequirementTypeLookupValueId !== `undefined` && x.fkMinimumRequirementTypeLookupValueId?.value) ? btoa(x.fkMinimumRequirementTypeLookupValueId.value) : ``,
                minPurchaseAmount: x.minPurchaseAmount,
                minPurchaseQty: null,
                maxPurchaseQty: null,
                fkMaxLimitTypeLookupValueId: null,
                maxAllowedQty: null,
                maxAllowedValue: null,
                totalUsageLimit: x.limitToOneUsePerCustomer ? null : (x?.totalUsageLimit || 1),
                limitToOneUsePerCustomer: x.limitToOneUsePerCustomer,
                requiredQuantity: null,
                active: true
            }));
        }

        if (enhancedData && enhancedData?.isSetDateRange && enhancedData?.dateRanges && Array.isArray(enhancedData.dateRanges) && enhancedData.dateRanges.length > 0) {
            payload.dateRanges = enhancedData.dateRanges.map((x: any) => ({
                discountScheduleDateRangeId: ``,
                startDate: formatDateForAPI(x.startDate),
                endDate: formatDateForAPI(x.endDate, true)
            }));
        } else {
            payload.dateRanges = [];
        }

        if (enhancedData && enhancedData?.isSetSchedule && enhancedData.isSetSchedule === true && enhancedData?.weeklySchedules && Array.isArray(enhancedData.weeklySchedules) && enhancedData.weeklySchedules.length > 0) {
            payload.weeklySchedules = enhancedData.weeklySchedules.filter((x: any) => x.isActive).map((x: any) => {
                var lobj = {
                    discountScheduleWeeklyId: ``,
                    dayOfWeek: x.dayOfWeek,
                    startTime: x.startTime ? moment(x.startTime).utc().format(`HH:mm`) : null,
                    endTime: x.endTime ? moment(x.endTime).utc().format(`HH:mm`) : null,
                    // startTime: x.startTime ? moment(x.startTime).format(`HH:mm`) : null,
                    // endTime: x.endTime ? moment(x.endTime).format(`HH:mm`) : null,
                    isActive: x.isActive
                };
                if (discount && discount.weeklySchedules && Array.isArray(discount.weeklySchedules)) {
                    //console.log(discount.weeklySchedules, x.value)
                    const existSchedule = discount.weeklySchedules.find((y: any) => y.dayOfWeek == x.dayOfWeek);
                    if (existSchedule) {
                        lobj.discountScheduleWeeklyId = existSchedule.discountScheduleWeeklyId;
                    }
                }
                return lobj;
            });
        } else {
            payload.weeklySchedules = [];
        }

        // Process discount combinations
        if (enhancedData && enhancedData?.discountCombination && Array.isArray(enhancedData.discountCombination) && enhancedData.discountCombination.length > 0) {
            payload.discountCombination = enhancedData.discountCombination.map((x: any) => ({
                fkCombinationsLookupValueId: btoa(x.value)
            }));
        } else {
            payload.discountCombination = [];
        }

        delete payload.ui_maxdiscountallowed;
        payload.discountCode = generateUniqueCode(10);
        console.log("Final processed payload is: ->", payload);
        setSaving(true);
        showLoader();
        const couponresp: any = await new Promise((resolve, reject) => discountApi.addUpdateDiscount(payload, resolve, reject)).catch(err => null);
        setSaving(false);
        hideLoader();
        console.log("Coupon Response", couponresp);
        if (couponresp && couponresp?.success && couponresp.success == true) {
            toast.success(t("orderDiscount.toasts.saveSuccess"));
            navigate(URLS.DISCOUNT);
        } else {
            toast.error(couponresp?.errorMessage || t("orderDiscount.toasts.saveFailed"));
        }

    };

    const handleCancel = () => {
        navigationConfirm(
            t("common.leaveDialog.title"),
            t("common.leaveDialog.message"),
            () => navigate(URLS.DISCOUNT),
            confirm
        );
    };

    useEffect(() => {
        console.log("Discount is -> ", discount);
        if (discount) {
            setValue(`discountId`, discount.discountId || null);
            setValue(`fkDiscountTypeLookupValueId`, discount.fkDiscountTypeLookupValueId);
            setValue(`discountName`, discount.discountName || ``);
            setValue(`discountDescription`, discount.discountDescription || ``);
            setValue(`isAutomatic`, discount.isAutomatic);
            setValue(`discountCode`, discount.discountCode);
            setValue(`isSetDateRange`, discount.isSetDateRange);
            setValue(`isSetSchedule`, discount.isSetSchedule);
            setValue(`active`, discount.active);
            setValue(`fkCustomerTargetTypeLookupValueId`, discount.fkCustomerTargetTypeLookupValueId);
            setValue(`locations`, discount.locations);
            setValue(`customerGroups`, discount.customerGroups);
            
            // Set discount combinations state for SelectBox
            const combinationsField = discount.combinations || discount.discountCombination;
            if (combinationsField && Array.isArray(combinationsField)) {
                const combinationOptions = combinationsField.map((o: any) => {
                    const lookupId = parseInt(atob(o.fkCombinationsLookupValueId)); // Convert to number
                    const lookupItem = lookup.getDiscountCombination()?.find((item: any) => item.lookupId === lookupId);
                    return {
                        label: lookupItem ? getLookupDisplayValue(lookupItem, t) : '',
                        value: lookupId
                    };
                }).filter((item: any) => item.label); // Filter out items where label is empty
                setDiscountCombinations(combinationOptions);
            }
            
            maxdiscountrenderRef.current = true;
            if (discount.rules && Array.isArray(discount.rules) && discount.rules.length > 0) {
                setValue(`rules`, discount.rules.map((x: any) => {
                    //console.log("x.limitToOneUsePerCustomer", x.limitToOneUsePerCustomer, x.totalUsageLimit);
                    return {
                        discountRuleId: x.discountRuleId,
                        fkDiscountValueTypeLookupValueId: x.fkDiscountValueTypeLookupValueId,
                        discountValue: x.discountValue,
                        fkMinimumRequirementTypeLookupValueId: x.fkMinimumRequirementTypeLookupValueId,
                        minPurchaseAmount: x.minPurchaseAmount,
                        minPurchaseQty: x.minPurchaseQty,
                        maxPurchaseQty: x.maxPurchaseQty,
                        fkMaxLimitTypeLookupValueId: x.fkMaxLimitTypeLookupValueId,
                        maxAllowedQty: x.maxAllowedQty,
                        maxAllowedValue: x.maxAllowedValue,
                        totalUsageLimit: `` + x.totalUsageLimit,
                        limitToOneUsePerCustomer: x.limitToOneUsePerCustomer,
                        requiredQuantity: x.requiredQuantity,
                        active: x.active
                    }
                }));

            }

            if (discount.isSetDateRange && discount.dateRanges && Array.isArray(discount.dateRanges) && discount.dateRanges.length > 0) {
                setValue(`dateRanges`, discount.dateRanges.map((x: any) => {
                    return {
                        discountScheduleDateRangeId: x.discountScheduleDateRangeId,
                        // startDate: x.startDate ? moment.utc(x.startDate).toDate() : ``,
                        // endDate: x.endDate ? moment.utc(x.endDate).toDate() : ``,
                        startDate: x.startDate ? moment.utc(x.startDate).local().toDate() : ``,
                        endDate: x.endDate ? moment.utc(x.endDate).local().toDate() : ``
                    }
                }));
            }

            if (discount.isSetSchedule && discount.weeklySchedules && Array.isArray(discount.weeklySchedules) && discount.weeklySchedules.length > 0) {
                const wkarr: any = [];
                setValue(`weeklySchedules`, Object.keys(dayNameObj).map((x: any) => {
                    const wkobj: any = discount.weeklySchedules.find((y: any) => y.dayOfWeek == x);
                    return {
                        discountScheduleWeeklyId: wkobj?.discountScheduleWeeklyId || null,
                        dayOfWeek: wkobj?.dayOfWeek || x,
                        // If They send proper date-time ISO string.
                        // startTime: wkobj?.startTime ? moment.utc(wkobj.startTime).toDate() : null,
                        // endTime: wkobj?.endTime ? moment.utc(wkobj.endTime).toDate() : null,
                        startTime: wkobj?.startTime ? moment.utc(`2025-01-01 ` + wkobj.startTime).toDate() : null,
                        endTime: wkobj?.endTime ? moment.utc(`2025-01-01 ` + wkobj.endTime).toDate() : null,
                        isActive: (wkobj ? true : false)
                    }
                }));
            }
        }
    }, []);

    useEffect(() => {
        //console.log("discount ui_maxdiscountallowedWatch", ui_maxdiscountallowedWatch, discount);
        if (ui_maxdiscountallowedWatch && typeof ui_maxdiscountallowedWatch !== `undefined` && typeof ui_maxdiscountallowedWatch === `object` && (ui_maxdiscountallowedWatch as any)?.value) {
            setValue(`rules.0.limitToOneUsePerCustomer`, ((ui_maxdiscountallowedWatch as any)?.value === 130));
            //if (!maxdiscountrenderRef.current)
                setValue(`rules.0.totalUsageLimit`, (ui_maxdiscountallowedWatch as any)?.value === 130 ? `1` : (getValues(`rules.0.totalUsageLimit`) > 0 ? getValues(`rules.0.totalUsageLimit`) : `1`));

        } else {
            setValue(`rules.0.limitToOneUsePerCustomer`, false);
            //if (!maxdiscountrenderRef.current)
                //setValue(`rules.0.totalUsageLimit`, `0`);
        }

    }, [ui_maxdiscountallowedWatch]);

    useEffect(() => {
        if (
          ui_minrequirementtyopevalues &&
          typeof ui_minrequirementtyopevalues !== `undefined` &&
          typeof ui_minrequirementtyopevalues === `object` &&
          (ui_minrequirementtyopevalues as any)?.value
        ) {
          const val = (ui_minrequirementtyopevalues as any)?.value;
          if (val == `125`) {
            setValue(`rules.0.minPurchaseAmount`, `0.00`);
          }
        }
    }, [ui_minrequirementtyopevalues]);

    // Clear customer groups when switching to "all customers"
    useEffect(() => {
        if (fkCustomerTargetTypeLookupValueIdWatch === btoa(`139`)) {
            setValue(`customerGroups`, []);
        }
    }, [fkCustomerTargetTypeLookupValueIdWatch]);

    // Validation messages (rules={{ required: t(...) }}) are resolved once, at the
    // moment validation runs, and cached as plain strings in react-hook-form's error
    // state -- they don't re-render on their own. Re-validate any already-errored
    // fields on a language switch so their messages catch up to the new language.
    useEffect(() => {
        if (Object.keys(errors).length > 0) {
            trigger();
        }
    }, [i18n.language]);

    return (
      <div>
        <SubHeader title={t("orderDiscount.page.title")} subTitle={t("orderDiscount.page.subtitle")}>
          <SiteButtons
            data={[
              { text: t("orderDiscount.buttons.cancel"), ...(!saving && { click: handleCancel }), theme: "secondary" },
              {
                text: discount ? t("orderDiscount.buttons.update") : t("orderDiscount.buttons.save"),
                type: "submit",
                form: "createOrderDiscountForm",
                working: saving,
              },
            ]}
          />
        </SubHeader>
        <Container>
          <div className="flex-grow overflow-auto">
            <form
              onSubmit={handleSubmit(onSubmit)}
              id="createOrderDiscountForm"
            >
              <div className="pb-6 pt-6">
                {/* General Section */}
                <div>
                  <div className={`border-b border-gray-300 pb-2 mb-6 `}>
                    <h2 className="text-lg font-semibold mb-2 text-black">
                      {t("orderDiscount.sections.general")}
                    </h2>
                    <p className="mb-4 text-sm text-black">
                      {t("orderDiscount.sections.generalSubtitle")}
                    </p>
                  </div>
                  <div className="grid grid-cols-1 gap-6 mb-6">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-normal text-black flex items-center gap-1">
                        {t("orderDiscount.toggles.manual")}
                        <span className="cursor-pointer text-secondary"><Icon name="info" size={16} title={t("orderDiscount.toggles.manualInfo")} /></span>
                      </span>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer hidden"
                          {...control.register("isAutomatic")}
                        />
                        <div className="w-11 h-6 bg-tertiary relative peer-focus:outline-none after:content-[''] after:top-1 after:absolute after:block after:w-4 after:h-4 after:bg-white after:rounded-full after:left-1 peer-focus:ring-blue-500 rounded-full peer peer-checked:bg-secondary peer-checked:after:right-1 peer-checked:after:left-auto  transition-all"></div>
                        <span className="ml-2 text-sm font-normal text-black">
                          {t("orderDiscount.toggles.automatic")}
                        </span>
                      </label>
                    </div>
                    {/*
                                    <Controller
                                        name="discountCode"
                                        control={control}
                                        //rules={!isAutomaticWatch ? { required: "Discount code is required" } : {}}
                                        //disabled={isAutomaticWatch}                                        
                                        render={({ field, fieldState }) => (
                                            <Input
                                                {...field}
                                                className="!my-0"
                                                type="text"
                                                label={t("orderDiscount.fields.discountCode")}
                                                //required={!isAutomaticWatch}
                                                //disabled={isAutomaticWatch}
                                                disabled
                                                placeholder={t("orderDiscount.placeholders.enterDiscountCode")}
                                                error={fieldState.error?.message}
                                            />
                                        )}
                                    />
                                    */}
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <Controller
                        name="discountName"
                        control={control}
                        rules={{
                          required: t("orderDiscount.validation.codeRequired"),
                          validate: (value: string | undefined) =>
                            !!(value?.trim()) || t("orderDiscount.validation.codeRequired"),
                        }}
                        render={({ field, fieldState }) => (
                          <Input
                            {...field}
                            className="!my-0 !mb-6"
                            type="text"
                            label={t("orderDiscount.fields.discountCode")}
                            required
                            placeholder={t("orderDiscount.placeholders.enterDiscountCode")}
                            error={fieldState.error?.message}
                          />
                        )}
                      />
                      <div>
                        <CommonDropdown
                          control={control}
                          setValue={setValue}
                          preSelectValues={
                            discount &&
                            discount.locations &&
                            Array.isArray(discount.locations)
                              ? discount.locations.map(
                                  (o: any) => o.fkLocationId
                                )
                              : null
                          }
                          rules={{ required: t("orderDiscount.validation.locationRequired") }}
                          label={t("orderDiscount.fields.location")}
                          name="locations"
                          type="location"
                          placeholder={t("orderDiscount.placeholders.selectLocation")}
                          required={true}
                          isMulti={true}
                        />
                      </div>
                    </div>
                    <Controller
                      name="discountDescription"
                      control={control}
                      render={({ field, fieldState }) => (
                        <Textarea
                          {...field}
                          className="!my-0 w-full"
                          mainElementClassName={`h-[132px]`}
                          label={t("orderDiscount.fields.discountDescription")}
                          placeholder={t("orderDiscount.placeholders.description")}
                          error={fieldState.error?.message}
                        />
                      )}
                    />
                  </div>
                </div>

                {/* Discount Rule Section */}
                <div>
                  <div className={`border-b border-gray-300 pb-2 mb-6 `}>
                    <h2 className="text-lg font-semibold mb-2 text-black">
                      {t("orderDiscount.sections.discountRule")}
                    </h2>
                    <p className="mb-4 text-sm text-black">
                      {t("orderDiscount.sections.discountRuleSubtitle")}
                    </p>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-0">
                    <CommonDropdown
                      preSelectValues={
                        discount &&
                        discount.rules &&
                        Array.isArray(discount.rules) &&
                        discount.rules[0] &&
                        discount.rules[0].fkDiscountValueTypeLookupValueId
                          ? atob(
                              discount.rules[0].fkDiscountValueTypeLookupValueId
                            )
                          : '48'
                      }
                      control={control}
                      setValue={setValue}
                      label={t("orderDiscount.fields.discountType")}
                      name="rules.0.fkDiscountValueTypeLookupValueId"
                      type="lookup"
                      placeholder={t("orderDiscount.placeholders.selectDiscountType")}
                      required
                      rules={{ required: t("orderDiscount.validation.discountTypeRequired") }}
                      data={lookup.getDiscountType()}
                    />
                    <Controller
                      name="rules.0.discountValue"
                      control={control}
                      rules={{ required: t("orderDiscount.validation.discountValueRequired"),
                         validate: (value) => {
                          const numValue = Number(value);
                          const discountTypeValue = discountType; // This is from watch()

                          // Check if it's a valid number
                          if (isNaN(numValue)) {
                            return t("orderDiscount.validation.discountValueInvalid");
                          }

                          // Fixed amount discount (assuming ID 47 is fixed amount)
                          if (discountTypeValue == 47) {
                            if (numValue < 0) {
                              return t("orderDiscount.validation.fixedDiscountMin");
                            }
                            if (numValue > 1000) {
                              return t("orderDiscount.validation.fixedDiscountMax");
                            }
                          }
                          // Percentage discount (assuming other IDs are percentage)
                          else {
                            if (numValue < 0) {
                              return t("orderDiscount.validation.percentDiscountMin");
                            }
                            if (numValue > 100) {
                              return t("orderDiscount.validation.percentDiscountMax");
                            }
                          }

                          return true;
                        },
                       }}
                      render={({ field, fieldState }) => (
                        <DecimalInput
                          value={field.value}
                          onChange={field.onChange}
                          decimalPlaces={2}
                          min={0}
                          max={discountType == 47 ? 9999999999 : 100}
                          className="!my-0 !mb-6"
                          label={t("orderDiscount.fields.discountValue")}
                          placeholder="0"
                          required
                          withDollarIcon={discountType == 47}
                          error={fieldState.error?.message as any}
                        />
                      )}
                    />
                    <CommonDropdown
                      preSelectValues={
                        discount &&
                        discount.rules &&
                        Array.isArray(discount.rules) &&
                        discount.rules[0] &&
                        discount.rules[0]?.fkMinimumRequirementTypeLookupValueId
                          ? atob(
                              discount.rules[0]
                                .fkMinimumRequirementTypeLookupValueId
                            )
                          : null
                      }
                      control={control}
                      setValue={setValue}
                      label={t("orderDiscount.fields.minimumPurchaseRequirement")}
                      name="rules.0.fkMinimumRequirementTypeLookupValueId"
                      type="lookup"
                      placeholder={t("orderDiscount.placeholders.minimumRequirements")}
                      required
                      rules={{
                        required: t("orderDiscount.validation.minimumPurchaseRequirementRequired"),
                      }}
                      data={lookup.getDiscountMinPurchaseAmount()}
                      labelisElipsis={true}
                    />
                    <Controller
                      name="rules.0.minPurchaseAmount"
                      control={control}
                      rules={
                        (ui_minrequirementtyopevalues as any)?.value == 126
                          ? { required: t("orderDiscount.validation.minPurchaseAmountRequired") }
                          : {}
                      }
                      disabled={
                        (ui_minrequirementtyopevalues as any)?.value === 125
                      }
                      render={({ field, fieldState }) => (
                        <DecimalInput
                          value={field.value ?? undefined}
                          onChange={field.onChange}
                          decimalPlaces={2} // allows decimals
                          min={0}
                          max={9999999999} // set max as needed
                          className="!my-0 !mb-6"
                          label={t("orderDiscount.fields.minPurchaseAmount")}
                          placeholder="0.00"
                          required={
                            (ui_minrequirementtyopevalues as any)?.value == 126
                          }
                          disabled={
                            (ui_minrequirementtyopevalues as any)?.value === 125
                          }
                          withDollarIcon={true}
                          error={fieldState.error?.message}
                        />
                      )}
                    />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-0">
                    <CommonDropdown
                      preSelectValues={
                        discount &&
                        discount.rules &&
                        Array.isArray(discount.rules) &&
                        discount.rules[0]
                          ? discount.rules[0].limitToOneUsePerCustomer
                            ? 130
                            : 129
                          : null
                      }
                      control={control}
                      setValue={setValue}
                      label={t("orderDiscount.fields.maximumDiscountUser")}
                      name="ui_maxdiscountallowed"
                      type="lookup"
                      placeholder={t("orderDiscount.placeholders.maximumDiscountUser")}
                      required
                      rules={{ required: t("orderDiscount.validation.maximumDiscountUserRequired") }}
                      data={lookup.getDiscountUsageLimit()}
                    />
                    <Controller
                      name="rules.0.totalUsageLimit"
                      control={control}
                      rules={
                        (ui_maxdiscountallowedWatch as any) &&
                        (ui_maxdiscountallowedWatch as any)?.value !== 130
                          ? { required: t("orderDiscount.validation.totalUsageLimitRequired"),
                              validate: (value) => {
                                const numValue = Number(value);
                                if (isNaN(numValue)) {
                                  return t("orderDiscount.validation.maximumDiscountUsageInvalid");
                                }
                                if (numValue < 1) {
                                  return t("orderDiscount.validation.maximumDiscountUsageMin");
                                }
                                return true;
                              },
                           }
                          : {}
                      }
                      disabled={
                        (ui_maxdiscountallowedWatch as any) &&
                        (ui_maxdiscountallowedWatch as any)?.value === 130
                      }
                      render={({ field, fieldState }) => (
                        <DecimalInput
                          value={field.value ?? undefined}
                          onChange={field.onChange}
                          fieldType="unit" // restricts to whole numbers
                          min={0}
                          max={9999999999}
                          className="!my-0 !mb-6"
                          label={t("orderDiscount.fields.maxAllowedValue")}
                          placeholder="0"
                          disabled={
                            (ui_maxdiscountallowedWatch as any) &&
                            (ui_maxdiscountallowedWatch as any)?.value === 130
                          }
                          required={
                            (ui_maxdiscountallowedWatch as any) &&
                            (ui_maxdiscountallowedWatch as any)?.value !== 130
                          }
                          error={fieldState.error?.message}
                        />
                      )}
                    />
                  </div>
                  {/* <div className="mb-8">
                    <div className="flex items-center gap-1" title="This product discount can be combined with">
                      <Label text="Combinations" />
                      <Icon name="info" className=" text-secondary cursor-pointer" title="This product discount can be combined with"/>
                    </div>
                    <SelectBox
                      value={discountCombinations}
                      onChange={(selectedOptions: any) => {
                        setDiscountCombinations(selectedOptions || []);
                      }}
                      options={
                        lookup.getDiscountCombination()?.map((item: any) => ({
                          label: item.lookupValue,
                          value: item.lookupId,
                        })) || []
                      }
                      placeholder="Select Combinations"
                      isMulti={true}
                      className="w-full !my-0"
                      isClearable={true}
                    />
                  </div> */}
                </div>

                {/* Discount Schedule */}
                <div>
                  <div className={`border-b border-gray-300 pb-2 mb-6`}>
                    <h2 className="text-lg font-semibold mb-2 text-black">
                      {t("orderDiscount.sections.discountSchedule")}
                    </h2>
                    <p className="mb-4 text-sm text-black"></p>
                  </div>

                  {/* Date Range */}
                  <div>
                    <div className="flex items-center gap-6 mb-6">
                      <div className="flex items-center gap-2">
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            className="sr-only peer hidden"
                            {...control.register("isSetDateRange")}
                          />
                          <div className="w-11 h-6 bg-tertiary relative peer-focus:outline-none after:content-[''] after:top-1 after:absolute after:block after:w-4 after:h-4 after:bg-white after:rounded-full after:left-1 peer-focus:ring-blue-500 rounded-full peer peer-checked:bg-secondary peer-checked:after:right-1 peer-checked:after:left-auto  transition-all"></div>
                          <span className="ml-2 text-sm font-semibold text-black">
                            {t("orderDiscount.toggles.setDateRange")}
                          </span>
                        </label>
                      </div>
                    </div>
                    <div
                      className={`relative mb-6 ${
                        !isSetDateRangeWatch
                          ? `after:content-[''] after:left-0 after:right-0 after:top-0 after:bottom-0 after:absolute after:block after:h-full after:w-full after:bg-white after:bg-opacity-50`
                          : ``
                      }`}
                    >
                      <div className="border border-gray-300 bg-white p-1.5 rounded-md overflow-hidden">
                        <div className="grid grid-cols-2 bg-[#e3e4e9] text-black text-sm font-medium">
                          <div className="px-2.5 py-4 border-r border-gray-100">
                            {t("orderDiscount.schedule.period")}
                          </div>
                          <div className="px-2.5 py-4">{t("orderDiscount.schedule.date")}</div>
                        </div>
                        <div className="grid grid-cols-2 border-t border-white">
                          <div className="px-2.5 py-2 border-r bg-[#e3e4e9] border-gray-300 flex items-center w-full text-sm font-normal text-black">
                            {t("orderDiscount.schedule.start")}
                          </div>
                          <div className="px-2.5 py-2">
                            <Controller
                              name="dateRanges.0.startDate"
                              control={control}
                              disabled={!isSetDateRangeWatch}
                              render={({ field }) => (
                                <div className="flex items-center">
                                  <div className="w-full grow">
                                    <DatePicker
                                      selected={field.value}
                                      onChange={(date) => {
                                        field.onChange(date);
                                        if (
                                          scheduleenddateWatch &&
                                          moment(date).isAfter(
                                            moment(scheduleenddateWatch)
                                          )
                                        ) {
                                          setValue(
                                            `dateRanges.0.endDate`,
                                            null
                                          );
                                        }
                                      }}
                                      icon={<Icon name="calendar" />}
                                      showIcon
                                      showYearDropdown
                                      dropdownMode="select"
                                      showMonthDropdown
                                      toggleCalendarOnIconClick
                                      placeholderText="MM/DD/YYYY"
                                      className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                      wrapperClassName="w-full"
                                      calendarIconClassName={`right-0 text-gray-400 top-1`}
                                      dateFormat="MM/dd/YYYY"
                                      disabled={!isSetDateRangeWatch}
                                      minDate={moment().toDate()}
                                    />
                                  </div>
                                </div>
                              )}
                            />
                          </div>
                        </div>
                        <div className="grid grid-cols-2 border-t border-white">
                          <div className="px-2.5 py-2 border-r bg-[#e3e4e9] border-gray-300 flex items-center w-full text-sm font-normal text-black">
                            {t("orderDiscount.schedule.end")}
                          </div>
                          <div className="px-2.5 py-2">
                            <Controller
                              name="dateRanges.0.endDate"
                              control={control}
                              disabled={!isSetDateRangeWatch}
                              render={({ field }) => (
                                <div className="flex items-center">
                                  <div className="w-full grow">
                                    <DatePicker
                                      selected={field.value}
                                      onChange={(date) => field.onChange(date)}
                                      showIcon
                                      showYearDropdown
                                      dropdownMode="select"
                                      showMonthDropdown
                                      icon={<Icon name="calendar" />}
                                      toggleCalendarOnIconClick
                                      placeholderText="MM/DD/YYYY"
                                      className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                      wrapperClassName="w-full"
                                      calendarIconClassName={`right-0 text-gray-400 top-1`}
                                      dateFormat="MM/dd/YYYY"
                                      disabled={!isSetDateRangeWatch}
                                      minDate={
                                        schedulestartdateWatch &&
                                        typeof schedulestartdateWatch !==
                                          `undefined` &&
                                        schedulestartdateWatch
                                          ? moment(
                                              schedulestartdateWatch
                                            ).toDate()
                                          : moment().toDate()
                                      }
                                    />
                                  </div>
                                </div>
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Weekly Schedule */}
                  <div>
                    <div className="flex items-center gap-6 mb-6">
                      <div className="flex items-center gap-2">
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            className="sr-only peer hidden"
                            {...control.register("isSetSchedule")}
                          />
                          <div className="w-11 h-6 bg-tertiary relative peer-focus:outline-none after:content-[''] after:top-1 after:absolute after:block after:w-4 after:h-4 after:bg-white after:rounded-full after:left-1 peer-focus:ring-blue-500 rounded-full peer peer-checked:bg-secondary peer-checked:after:right-1 peer-checked:after:left-auto  transition-all"></div>
                          <span className="ml-2 text-sm font-semibold text-black">
                            {t("orderDiscount.toggles.setSchedule")}
                          </span>
                        </label>
                      </div>
                    </div>
                    <div
                      className={`relative mb-6 ${
                        !isSetScheduleWatch
                          ? `after:content-[''] after:left-0 after:right-0 after:top-0 after:bottom-0 after:absolute after:block after:h-full after:w-full after:bg-white after:bg-opacity-50`
                          : ``
                      }`}
                    >
                      <div className="border border-gray-300 bg-white p-1.5 rounded-md overflow-hidden">
                        <div className="flex items-center bg-[#e3e4e9] text-black text-sm font-medium">
                          <div className="px-2.5 py-4 border-r border-gray-100 w-20"></div>
                          <div className="grid grid-cols-3 w-full">
                            <div className="px-2.5 py-4 border-r border-gray-100">
                              {t("orderDiscount.schedule.days")}
                            </div>
                            <div className="px-2.5 py-4 border-r border-gray-100">
                              {t("orderDiscount.schedule.startTime")}
                            </div>
                            <div className="px-2.5 py-4">{t("orderDiscount.schedule.endTime")}</div>
                          </div>
                        </div>
                        {weeklySchedulesWatch.map(
                          (wkschedule: any, index: number) => {
                            return (
                              <div
                                className="flex items-center border-t border-white"
                                key={`wk-` + index}
                              >
                                <label className="px-2.5 py-2 w-20 bg-white border-r border-gray-300 flex justify-center items-center">
                                  <input
                                    type="checkbox"
                                    disabled={!isSetScheduleWatch}
                                    {...control.register(
                                      `weeklySchedules.${index}.isActive`
                                    )}
                                  />
                                </label>
                                <div className="grid grid-cols-3 w-full">
                                  <div className="px-2.5 py-2 border-r bg-[#e3e4e9] border-gray-300 flex items-center w-full text-sm font-normal text-black">
                                    {(dayNameObj as any)[wkschedule.dayOfWeek]}
                                    {wkschedule.isActive && (
                                      <span className="text-red-600 ml-1">
                                        *
                                      </span>
                                    )}
                                  </div>
                                  <div className="px-2.5 py-2">
                                    <Controller
                                      name={`weeklySchedules.${index}.startTime`}
                                      control={control}
                                      disabled={
                                        !isSetScheduleWatch ||
                                        !wkschedule.isActive
                                      }
                                      rules={
                                        wkschedule.isActive
                                          ? {
                                              required:
                                                t("orderDiscount.validation.startTimeRequired"),
                                            }
                                          : {}
                                      }
                                      render={({ field }) => (
                                        <div className="flex items-center">
                                          <div className="w-full grow">
                                            <DatePicker
                                              selected={field.value}
                                              onChange={(date) => {
                                                field.onChange(date);
                                                if (
                                                  wkschedule.endTime &&
                                                  date &&
                                                  moment(date).isSameOrAfter(
                                                    moment(wkschedule.endTime)
                                                  )
                                                ) {
                                                  const startMoment = moment(date);
                                                  const maxEndTime = moment(moment().format(`YYYY-MM-DD 23:55:00`));
                                                  let newEndTime = startMoment.clone().add(5, `minutes`);
                                                  
                                                  // Cap end time at 11:55 PM
                                                  if (newEndTime.isAfter(maxEndTime)) {
                                                    newEndTime = maxEndTime;
                                                  }
                                                  
                                                  setValue(
                                                    `weeklySchedules.${index}.endTime`,
                                                    newEndTime.toDate()
                                                  );
                                                }
                                              }}
                                              icon={<Icon name="clock" />}
                                              showIcon
                                              toggleCalendarOnIconClick
                                              placeholderText="HH:MM"
                                              className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                              wrapperClassName="w-full"
                                              calendarIconClassName={`right-0 text-gray-400 top-1`}
                                              showTimeSelect
                                              showTimeSelectOnly
                                              timeIntervals={5}
                                              dateFormat="hh:mm aaaa"
                                              showTimeCaption={true}
                                              disabled={
                                                !isSetScheduleWatch ||
                                                !wkschedule.isActive
                                              }
                                              minTime={moment(
                                                moment().format(
                                                  `YYYY-MM-DD 00:00:00`
                                                )
                                              ).toDate()}
                                              maxTime={moment(
                                                moment().format(
                                                  `YYYY-MM-DD 23:50:00`
                                                )
                                              ).toDate()}
                                              required={wkschedule.isActive}
                                            />
                                          </div>
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="px-2.5 py-2">
                                    <Controller
                                      name={`weeklySchedules.${index}.endTime`}
                                      control={control}
                                      disabled={
                                        !isSetScheduleWatch ||
                                        !wkschedule.isActive
                                      }
                                      rules={
                                        wkschedule.isActive
                                          ? {
                                              required:
                                                t("orderDiscount.validation.startTimeRequired"),
                                            }
                                          : {}
                                      }
                                      render={({ field }) => (
                                        <div className="flex items-center">
                                          <div className="w-full grow">
                                            <DatePicker
                                              selected={field.value}
                                              onChange={(date) =>
                                                field.onChange(date)
                                              }
                                              icon={<Icon name="clock" />}
                                              showIcon
                                              toggleCalendarOnIconClick
                                              placeholderText="HH:MM"
                                              className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                              wrapperClassName="w-full"
                                              calendarIconClassName={`right-0 text-gray-400 top-1`}
                                              showTimeSelect
                                              showTimeSelectOnly
                                              timeIntervals={5}
                                              dateFormat="hh:mm aaaa"
                                              showTimeCaption={true}
                                              disabled={
                                                !isSetScheduleWatch ||
                                                !wkschedule.isActive
                                              }
                                              minTime={
                                                wkschedule.startTime &&
                                                typeof wkschedule.startTime !==
                                                  `undefined` &&
                                                wkschedule.startTime
                                                  ? (() => {
                                                      const minTime = moment(wkschedule.startTime).add(5, `minutes`);
                                                      const maxTime = moment(moment().format(`YYYY-MM-DD 23:55:00`));
                                                      // If adding 5 minutes goes past 23:55, cap it at 23:55
                                                      return minTime.isAfter(maxTime) ? maxTime.toDate() : minTime.toDate();
                                                    })()
                                                  : moment(
                                                      moment().format(
                                                        `YYYY-MM-DD 00:00:00`
                                                      )
                                                    ).toDate()
                                              }
                                              maxTime={moment(
                                                moment().format(
                                                  `YYYY-MM-DD 23:55:00`
                                                )
                                              ).toDate()}
                                              required={wkschedule.isActive}
                                            />
                                          </div>
                                        </div>
                                      )}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Discount Target */}
                <div className="mt-8">
                  <div className={`border-b border-gray-300 pb-2 mb-6 `}>
                    <h2 className="text-lg font-semibold mb-2 text-black">
                      {t("orderDiscount.sections.discountTarget")}
                    </h2>
                    <p className="mb-4 text-sm text-black">
                      {t("orderDiscount.sections.discountTargetSubtitle")}
                    </p>
                  </div>
                  <div className="grid grid-cols-2 gap-1 mb-6">
                    <label>
                      <input
                        type="radio"
                        className="hidden sr-only peer"
                        value={btoa(`139`)}
                        {...control.register(
                          "fkCustomerTargetTypeLookupValueId"
                        )}
                      />
                      <span
                        className={`text-center cursor-pointer block bg-white px-5 py-5 border border-gray-50 rounded peer-checked:border-blue-500`}
                      >
                        {t("orderDiscount.target.allCustomers")}
                      </span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        className="hidden sr-only peer"
                        value={btoa(`140`)}
                        {...control.register(
                          "fkCustomerTargetTypeLookupValueId"
                        )}
                      />
                      <span
                        className={`text-center cursor-pointer block bg-white px-5 py-5 border border-gray-50 rounded peer-checked:border-blue-500`}
                      >
                        {t("orderDiscount.target.specificGroups")}
                      </span>
                    </label>
                  </div>

                  {/* Customer Groups Dropdown - Only show when specific customer groups is selected */}
                  {fkCustomerTargetTypeLookupValueIdWatch === btoa(`140`) && (
                    <div className="mb-6">
                      <CommonDropdown
                        control={control}
                        setValue={setValue}
                        preSelectValues={
                          discount &&
                          discount.customerGroups &&
                          Array.isArray(discount.customerGroups)
                            ? discount.customerGroups.map(
                                (cg: any) => cg.fkCustomerGroupId
                              )
                            : null
                        }
                        rules={{
                          required:
                            t("orderDiscount.validation.customerGroupsRequired"),
                        }}
                        label={t("orderDiscount.fields.customerGroups")}
                        name="customerGroups"
                        type="allCustomerGroups"
                        placeholder={t("orderDiscount.placeholders.selectCustomerGroups")}
                        required={true}
                        isMulti={true}
                      />
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </Container>
      </div>
    );
}

export default OrderDiscount;